<form
  *transloco="let t; read: 'configurations.configuration-item-editor-options-popout'"
  [formGroup]="form"
  class="configuration-item-editor-options-popout__form"
>
  <div class="configuration-item-editor-options-popout__title">{{ t('options') }}</div>

  <div class="configuration-item-editor-options-popout__section">
    <div class="configuration-item-editor-options-popout__label">{{ t('sort.label') }}</div>

    <div class="configuration-item-editor-options-popout__section">
      @for (sortRadio of sortRadios; track sortRadio) {
        <xi-radio
          color="CX"
          name="sort"
          formControlName="sort"
          [value]="sortRadio.value"
          [label]="sortRadio.label"
        ></xi-radio>
      }
    </div>

    <div class="configuration-item-editor-options-popout__label">{{ t('filter.label') }}</div>

    <div class="configuration-item-editor-options-popout__section">
      @for (filterRadio of filterRadios; track filterRadio) {
        <xi-radio
          color="CX"
          name="filter"
          formControlName="filter"
          [value]="filterRadio.value"
          [label]="filterRadio.label"
        ></xi-radio>
      }
    </div>

    <div class="configuration-item-editor-options-popout__label">{{ t('show-hidden') }}</div>

    <div class="configuration-item-editor-options-popout__section">
      <xi-toggle-switch
        color="CX"
        type="button"
        [isToggled]="form.controls.showHidden.value"
        (onToggle)="form.controls.showHidden.setValue($event.detail.isToggled)"
        [leftText]="t('show-hidden-toggle.off')"
        [rightText]="t('show-hidden-toggle.on')"
      ></xi-toggle-switch>
    </div>
  </div>
</form>
